import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_URL } from 'app/helpers/globals';
import { AdminSearchNode, AdminSearchType, SearchResponse } from 'app/views/reseller-admin-panel/reseller-admin-panel.model';

@Injectable({
    providedIn: 'root'
})
export class ResellerAdminPanelService {

    constructor(private readonly http: HttpClient) { }

    search(searchBy: AdminSearchType, byText: string): Observable<AdminSearchNode[]> {
        return this.http.post<SearchResponse>(`${API_URL}search`, { searchBy, byText }, { withCredentials: true })
            .pipe(map((response) => response.Data || []));
    }
}
